import JsFileDownloader from "js-file-downloader";
import { identity, pickBy } from "lodash-es";

export const downloadCsv = (queryParams = {}) => {
  const queryString = new URLSearchParams(
    pickBy(queryParams, identity)
  ).toString();
  new JsFileDownloader({
    url: `${import.meta.env.VITE_API_URL}/export/entries?${queryString}`,
    filename: "entries.csv",
  });
};
